// This icon file is generated automatically.
var PKeyOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M8.5.75a4.75 4.75 0 00-3.75 7.66l-.64.65-.98-.98a.13.13 0 00-.18 0l-.62.62a.13.13 0 000 .18l.98.98-.7.7-.98-.98a.13.13 0 00-.18 0l-.62.63a.13.13 0 000 .17l.97.98-1.02 1.02a.13.13 0 000 .17l.67.67c.04.04.12.04.17 0l3.96-3.97A4.75 4.75 0 108.5.75zm2.52 7.27a3.53 3.53 0 01-5.04 0 3.53 3.53 0 010-5.04 3.53 3.53 0 015.04 0 3.53 3.53 0 010 5.04z", "fill-rule": "nonzero" } }] }, "name": "p-key", "theme": "outlined" };
export default PKeyOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PKeyOutlined.js
// module id = 3477
// module chunks = 0